/* eslint-disable react/react-in-jsx-scope */
import { useLayoutEffect, useRef } from 'react';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress'
import { SxProps } from '@mui/system/styleFunctionSx/styleFunctionSx';

const DataLoading = () => {
  const topContaner = useRef(null);
  const userMessge = useRef(null);
  const progressIndicator = useRef(null);

  const topContainerProps: SxProps = { width: 1, backgroundColor: "#FFFFFF", textAlign: "center", p: 3 };

  const userMessgeProps: SxProps = { m: 2, color: "#24125F", fontSize: "24px" };

  const progressIndicatorProps: SxProps = { mt: "18px", color: "#24125F" };

  useLayoutEffect(() => {
    const container: HTMLElement = topContaner.current;
    container.style.height = (window.innerHeight - 50) + "px";
  });

  return (
    <Box ref={topContaner} sx={topContainerProps} >
      <Typography variant='subtitle1' ref={userMessge} sx={userMessgeProps} >Waiting for data to load...</Typography>
      <CircularProgress ref={progressIndicator} size="3rem" sx={progressIndicatorProps} />
    </Box>
  );

}

export default DataLoading;